//#region IMPORT
import { Box, Stack, Typography } from '@mui/material';
import FileButton from '../ui/FileButton';
import DocumentViewer from '../../../../Components/Ui/DocumentViewer';
//#endregion

export default function M_FILE_CUSTOM_02(props) {
  const fileUrl = props.fullUrl;
  const ext = props.getExtensionFromUrl(fileUrl);

  const isImage = ['jpg', 'jpeg', 'png'].includes(ext);
  const isPdf = ext === 'pdf';

  const renderViewer = () => {
    if (!fileUrl) {
      return (
        <Typography sx={{ color: '#4b4949ff', mt: 2 }}>
          교육 자료가 없습니다.
        </Typography>
      );
    }

    if (isImage) {
      return (
        <img
          src={fileUrl}
          alt="교육자료 이미지"
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '70vh',
            objectFit: 'contain',
          }}
        />
      );
    }

    if (isPdf) {
      return (
        <DocumentViewer
          fileUrl={fileUrl}
          renderPreview={props.renderPreview}
          loading={props.loading}
          onDocumentLoadSuccess={props.onDocumentLoadSuccess}
          pageNumber={props.pageNumber}
          pageWidth={props.pageWidth}
          pageViewHeight={props.pageViewHeight}
          setPageViewHeight={props.setPageViewHeight}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      );
    }

    return (
      <Typography sx={{ color: '#4b4949ff', mt: 2 }}>
        미리보기를 지원하지 않는 파일 형식입니다.
      </Typography>
    );
  };

  return (
    <>
      <Stack sx={{ display: 'flex', alignItems: 'start', m: 2, mt: 0 }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          작업계획서
        </Typography>
        <Typography sx={{ color: '#828282' }}>
          파일 자료를 통해 작업계획서를 확인해주세요.
        </Typography>
      </Stack>

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minHeight: 0,
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'auto',
          }}
        >
          {renderViewer()}
        </Box>

        <Box sx={{ flexShrink: 0, width: '100%' }}>
          <FileButton
            goToPrevPage={props.goToPrevPage}
            goToNextPage={props.goToNextPage}
            onAdvanceStep={() => props.setActiveStep(props.activeStep + 1)}
            pageNumber={props.pageNumber}
            numPages={props.numPages}
          />
        </Box>
      </Box>
    </>
  );
}
